// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__xrLyd","form":"styles_form__KOPqZ"};